var $ = require('jquery');

export function failureMsg() {
    let $e = $('.asmt-form-outer');
    $e.children().hide();
    $e.show();
    $e.find('.failure').show();
    $('.results-outer').hide();
}



// WEBPACK FOOTER //
// ./src/failure.js